module.exports = __webpack_public_path__ + "img/sam-tp.6e58ac6e.jpg";